(function () {
    'use strict';

    angular
        .module('authentication')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('login', {
                url: '/login',
                templateUrl: 'authentication/views/authentication.tpl.html',
                controller: 'AuthenticationCtrl',
                controllerAs: 'login'
            })
            .state('reset',{
                url:'/reset',
                templateUrl: 'authentication/views/change_password.tpl.html',
                controller: 'ChangePasswordCtrl',
                controllerAs: 'change'
            })
            .state('sso-callback', {
                url: '/sso-callback',
                template: '<div></div>',
                controller: 'SSOCallbackCtrl',
                controllerAs: 'ssoCallback'
            })
    }
}());
